import React, {useState} from 'react';
import { LABEL } from '../../veriables';
import OrderConfirmationPopUp from './orderConfirmationPopUp'

const SendOrderMode = ({ isOpen, onClose, deviceInfo, data, type, allMenusHashTable,menuItemsHashTable, cart, check, auth }) => {
  const orderSendMode = deviceInfo?.deviceGroup?.orderSendModes;
  const Options = [
    { key: 'toGo', label: LABEL().TOGO, isSuppoted: orderSendMode?.toGo },
    { key: 'onTheFly', label: LABEL().ON_THE_FLY, isSuppoted: orderSendMode?.rush },
    { key: 'doNotMake', label: LABEL().DO_NOT_MAKE, isSuppoted: orderSendMode?.doNoMake },
  ];
  const [isOpenPopUP, setIsOpenPopUP] = useState(false)
  const [selectedKey, setSelectedKey] = useState(null)

  const onCloseFunc = (item) => {
    let orderTypes = false;
    if (check.sourceType != 11) {
      for (let index = 0; index < auth?.orderTypes.length; index++) {
        const element = auth?.orderTypes[index];
        if (element.printRouting === true) {
          orderTypes = true
        }
      }
    }
    if (orderTypes === false) {
      onClose(item.key)    
      return
    }
    if (type ===  'sendSingle' || type === 'send'){
      const groupItem = allMenusHashTable?.filter(item => item.id == data[0].menuScreenId)
      if (groupItem[0]?.orderTypePrintRouting === true || menuItemsHashTable[data[0].menuItemId]?.orderTypePrintRouting === true){
        setIsOpenPopUP(true)
        setSelectedKey(item.key)
      } else {
        onClose(item.key)
        return
      }
    } else if (type ===  'sendAll' || type === 'send all') {
      for (let index = 0; index < cart.length; index++) {
        const element = cart[index];
        const groupItem = allMenusHashTable?.filter(item => item.id == element?.menuScreenId)
        if (groupItem[0]?.orderTypePrintRouting === true || menuItemsHashTable[element.menuItemId].orderTypePrintRouting === true) {
          setIsOpenPopUP(true)
          setSelectedKey(item.key)
          return
        }
      }
      onClose(item.key)
      return
    }
     else if (type ===  'send selected' || type === 'sendSelect'){
      let cart = data
      for (let index = 0; index < cart.length; index++) {
        const element = cart[index];
        const groupItem = allMenusHashTable?.filter(item => item.id == element.menuScreenId)
        if (groupItem[0]?.orderTypePrintRouting === true || menuItemsHashTable[element.menuItemId]?.orderTypePrintRouting === true) {
        setIsOpenPopUP(true)
        setSelectedKey(item.key)
        return
        }
      }
        onClose(item.key)
        return
    }
   
  }

  const onClosePopUp = (type, arr, orderId) => {
    onClose(selectedKey, arr, orderId, type)
  }
//checklisting
  return isOpen && (
    <div
      className="col-12 px-2 w-100 border rounded od-container-card-border background-primary od-app-background-color border-color-primary rounded od-border-primary h-100"
    >
      <div
        className="fs-24 od-text-primary text-primary py-2 px-0 text-right col-12"
        role="presentation"
        onClick={() => onClose(false)}
      >
        <i className="fa fa-times" aria-hidden="true" />
      </div>
      {Options.filter((e) => e.isSuppoted).map((item) => {
        return (
          <div
            role="presentation"
            onClick={() => onCloseFunc(item)}
            className="od-text-primary fs-12 text-center row mx-0 justify-content-center border my-2 p-2 border-color-secondary od-container-card-background  background-secondary rounded"
          >
            {item.label}
          </div>
        );
      })}
      {isOpenPopUP && <OrderConfirmationPopUp isOpen={isOpenPopUP} pendingActionType={type ===  'sendSingle' || type === 'send' ? {type: type, data:{selectedItem: data}} : type ===  'send selected' || type === 'sendSelect' ? {type: type, data:{selectedItem: data}} :  {type: type, data: {PendingItems: cart}}} actionTypes={type} seat={check} cart={cart} auth={auth} menusList={{screens:allMenusHashTable}} menuItemsHashTable={menuItemsHashTable} onClose={onClosePopUp}/>}
    </div>
  );
};

export default SendOrderMode;
